import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IndicatorsService } from '../../../../../services/indicators/indicators.service';
import { Observable } from 'rxjs/Observable';
import { isUndefined } from 'util';
import { Point } from '../../../../../models/pointWidget.model';


@Component({
  selector: 'app-fatturato-carta-indicator',
  templateUrl: './fatturato-carta-indicator.component.html',
  styleUrls: ['./fatturato-carta-indicator.component.css']
})
export class FatturatoCartaIndicatorComponent implements OnInit, OnChanges {

  @Input() data: any;
  @Input() detail: boolean;

  pointData: Point;
  penetration: Point;


  constructor(private indicatorService: IndicatorsService) {

  }

  ngOnInit() {
    if (isUndefined(this.data)) {
      return;
    }

    const requestName = ['FatturatoCarta'];
    if (this.detail) {
      requestName.push('FatturatoCartaPenetrazione');
    }

    const request = [];
    for (const name of requestName) {
      request.push(this.indicatorService.indicatorCalculation(name, this.data));
    }

    Observable.zip(...request).subscribe((res) => {
      this.pointData = res[0][0];
      this.penetration = res[0][1];
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!isUndefined(changes['data'].currentValue)) {
      this.ngOnInit();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/widgets/value/fatturato-carta-indicator/fatturato-carta-indicator.component.ts